import { PELE_PADRAO, peleValida } from '../look/pele';
import { api } from '../api';
import { etagAtual } from '../data/mundoSync';

export const NPC_ID_BASE = 50000;
export const NPC_ALCANCE_PADRAO = 2;
export const NPC_ALCANCE_MIN = 1;
export const NPC_ALCANCE_MAX = 32;

export interface NpcNoMapa {
  readonly id: string;
  readonly nome: string;
  readonly titulo: string;
  readonly x: number;
  readonly y: number;
  readonly dir: number;
  readonly corpo: string;
  readonly roupa: string;
  readonly pele: number;
  /** O fio das camadas (armadura + traje). Vazio: a `roupa` de antes. */
  readonly visual: string;
  readonly cabelo: string;
  readonly cabeloCor: number;
  readonly barba: string;
  readonly barbaCor: number;
  readonly mao: string;
  readonly esquerda: string;
  readonly alcance: number;
  readonly temLoja: boolean;
  readonly temCorretor: boolean;
  readonly temBanco: boolean;
  readonly lojaQtd: number;
  readonly lojaIcone: string | null;
}

const ID_OK = /^[a-z0-9-]+$/;
const VAZIO: readonly NpcNoMapa[] = [];

export function lerAlcance(raw: unknown): number {
  return typeof raw === 'number' && Number.isInteger(raw)
    && raw >= NPC_ALCANCE_MIN && raw <= NPC_ALCANCE_MAX
    ? raw
    : NPC_ALCANCE_PADRAO;
}

export function longeDoNpc(px: number, py: number, nx: number, ny: number, alcance: number): boolean {
  return Math.max(Math.abs(px - nx), Math.abs(py - ny)) > alcance;
}

export async function carregarNpcs(mapaArquivo: string, sinal?: AbortSignal): Promise<readonly NpcNoMapa[]> {
  const stem = mapaArquivo.replace(/\.json$/i, '');
  if (!ID_OK.test(stem)) return VAZIO;
  const etag = etagAtual() || '1-00000000';
  try {
    const lista = await api.npcsDoMundo(etag, stem);
    if (sinal?.aborted) return VAZIO;
    const out: NpcNoMapa[] = [];
    for (const n of lista) {
      if (!n.id || !ID_OK.test(n.id)) continue;
      if (!n.nome || n.nome.length > 24) continue;
      // Sem título é o NPC de enfeite (techspec-npc-editor): aparece, mas não fala nem atende.
      const corpo = n.corpo || '';
      if (!corpo || corpo === 'weapons' || corpo === 'cloth' || corpo === 'plates' || corpo === 'studded' || corpo === 'bone') continue;
      const pele = peleValida(n.pele) ? n.pele : PELE_PADRAO;
      out.push({
        id: n.id,
        nome: n.nome,
        titulo: n.titulo,
        x: n.x | 0,
        y: n.y | 0,
        dir: n.dir | 0,
        corpo,
        roupa: n.roupa || '',
        pele,
        visual: n.visual || '',
        cabelo: n.cabelo || '',
        cabeloCor: n.cabeloCor ?? 0,
        barba: n.barba || '',
        barbaCor: n.barbaCor ?? 0,
        mao: n.mao || '',
        esquerda: n.esquerda || '',
        alcance: lerAlcance(n.alcance),
        temLoja: !!n.temLoja,
        temCorretor: !!n.temCorretor,
        temBanco: !!n.temBanco,
        lojaQtd: n.lojaQtd ?? 0,
        lojaIcone: n.lojaIcone ?? null
      });
      if (out.length >= 1000) break;
    }
    return out;
  } catch {
    return VAZIO;
  }
}
